<template>
    <div class="container">
      <header class="page-header">
        <h1 class="page-title">{{ $t('Teams.title') }}</h1>
        <p class="page-subtitle">{{ $t('Teams.subtitle') }}</p>
      </header>

      <div class="team-cards">
        <div class="card">
          <div class="card-header">
            <div class="avatar-container">
              <div class="avatar-placeholder">
                <i class="fas fa-user"><img src="./../assets/darren.png" width="250px" height="250px"></i>
              </div>
            </div>
            <div class="member-info">
              <h2 class="member-name">
                <span>{{ $t('Teams.card1.name') }}</span>
              </h2>
              <p class="member-position">{{ $t('Teams.card1.position') }}</p>
              <p class="member-tagline">{{ $t('Teams.card1.tagline') }}</p>
            </div>
          </div>
          <div class="card-body">
            <div class="member-bio">
              <p>{{ $t('Teams.card1.bio1') }}</p>
              <p>{{ $t('Teams.card1.bio2') }}</p>
              <p>{{ $t('Teams.card1.bio3') }}</p>
            </div>
            <div class="member-highlights">
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card1.highlight1') }}</span>
              </div>
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card1.highlight2') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="avatar-container">
              <div class="avatar-placeholder">
                <i class="fas fa-user"><img src="./../assets/lynn.png" width="250px" height="250px"></i>
              </div>
            </div>
            <div class="member-info">
              <h2 class="member-name">
                <span>{{ $t('Teams.card2.name') }}</span>
              </h2>
              <p class="member-position">{{ $t('Teams.card2.position') }}</p>
              <p class="member-tagline">{{ $t('Teams.card2.tagline') }}</p>
            </div>
          </div>
          <div class="card-body">
            <div class="member-bio">
              <p>{{ $t('Teams.card2.bio1') }}</p>
              <p>{{ $t('Teams.card2.bio2') }}</p>
              <p>{{ $t('Teams.card2.bio3') }}</p>
            </div>
            <div class="member-highlights">
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card2.highlight1') }}</span>
              </div>
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card2.highlight2') }}</span>
              </div>
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card2.highlight3') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="avatar-container">
              <div class="avatar-placeholder">
                <i class="fas fa-user"><img src="./../assets/serin.png" width="250px" height="250px"></i>
              </div>
            </div>
            <div class="member-info">
              <h2 class="member-name">
                <span>{{ $t('Teams.card3.name') }}</span>
              </h2>
              <p class="member-position">{{ $t('Teams.card3.position') }}</p>
              <p class="member-tagline">{{ $t('Teams.card3.tagline') }}</p>
            </div>
          </div>
          <div class="card-body">
            <div class="member-bio">
              <p>{{ $t('Teams.card3.bio1') }}</p>
              <p>{{ $t('Teams.card3.bio2') }}</p>
              <p>{{ $t('Teams.card3.bio3') }}</p>
              <p>{{ $t('Teams.card3.bio4') }}</p>
              <p>{{ $t('Teams.card3.bio5') }}</p>
            </div>
            <div class="member-highlights">
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card3.highlight1') }}</span>
              </div>
              <div class="highlight-item">
                <span class="highlight-icon">✓</span>
                <span>{{ $t('Teams.card3.highlight2') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Teams',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 100px 0;
      line-height: 1.6;
    }

    /* 标题样式 */
    .page-header {
      text-align: center;
      margin-bottom: 50px;
      padding-bottom: 30px;
    }

    .page-title {
      font-size: 40px;
      color: #1e3a8a;
      margin-bottom: 10px;
      font-weight: 600;
    }

    .page-subtitle {
      font-size: 20px;
      color: #4b5563;
      max-width: 600px;
      margin: 0 auto;
    }

    /* 卡片容器样式 */
    .team-cards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
      gap: 40px;
    }

    /* 卡片样式 */
    .card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(37, 99, 235, 0.1);
      overflow: hidden;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      display: flex;
      flex-direction: column;
      border: 1px solid #dbeafe;
    }

    .card:hover {
      transform: translateY(-8px);
      box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
    }

    .card-header {
      background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
      color: white;
      padding: 30px;
      position: relative;
      display: flex;
      align-items: center;
    }

    .card-header::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(90deg, #60a5fa 0%, #93c5fd 100%);
    }

    .avatar-container {
      width: 250px;
      height: 250px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      overflow: hidden;
      flex-shrink: 0;
    }

    .avatar-placeholder {
      color: rgba(255, 255, 255, 0.7);
      font-size: 80px;
    }

    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .member-info {
      flex: 1;
    }

    .member-name {
      font-size: 30px;
      margin-bottom: 10px;
      font-weight: 600;
    }

    .member-position {
      font-size: 20px;
      opacity: 0.9;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .member-tagline {
      font-size: 15px;
      opacity: 0.8;
      font-style: italic;
    }

    .card-body {
      padding: 30px;
      flex-grow: 1;
      font-weight: 500;
    }

    .member-bio {
      color: #4b5563;
      font-size: 15px;
      margin-bottom: 20px;
    }

    .member-highlights {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #e5e7eb;
    }

    .highlight-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      font-size: 16px;
    }

    .highlight-icon {
      color: #2563eb;
      margin-right: 10px;
      font-size: 15px;
      margin-top: 3px;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
      .team-cards {
        grid-template-columns: 1fr;
      }

      .page-title {
        font-size: 30px;
      }

      .card-header {
        flex-direction: column;
        text-align: center;
      }

      .avatar-container {
        width: 200px;
        height: 200px;
        margin-right: 0;
        margin-bottom: 20px;
      }

      .member-name {
        font-size: 28px;
      }

      .member-position {
        font-size: 20px;
      }
    }

    @media (max-width: 480px) {
      .avatar-container {
        width: 180px;
        height: 180px;
      }

      .member-name {
        font-size: 24px;
      }

      .member-position {
        font-size: 18px;
      }
    }
</style>
